/*!
 * 
 * ------
 * Note: customizing files reduces the store's ability to auto-update the theme.
 *
 * Disclaimer:
 * This is a non minified version of a core js file, you can swap out the liquid / HTML link from the minified file if you choose to utilize this one. Any usage of these files is at the merchant/app/expert/agency's own risk, we take no responsibility for custom code changes. Support offerings from We Are Eight will be limited to rolling back to the latest theme version if these are utilized.
 *
 * License and acceptance of usage:
 *
 * Copyright (C) We Are Eight LTD  - All Rights Reserved
 * This file is part of Momentum theme provided for usage on Shopify online stores only.
 * Unauthorized usage and or modification of this file outside of this Momentum utilized on a Shopify store without a valid license, is strictly prohibited.
 * Unauthorized copying or distribution of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 *
 * More information and official contact details: weareeight.com
 * ------
 *
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 845:
/***/ ((module) => {

!function(e,d){ true?module.exports=d():0}(self,(function(){return(()=>{"use strict";var e={};return((e,d)=>{Object.defineProperty(d,"__esModule",{value:!0}),d.isArmadaLoaded=void 0,d.isArmadaLoaded=e=>{var d,o;const a=!0===(null===(o=null===(d=window.eight)||void 0===d?void 0:d.armada)||void 0===o?void 0:o.loaded);if(!e)return a;a?e():document.addEventListener("ARMADA:LOADED",e)},d.default=d.isArmadaLoaded})(0,e),e})()}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(845);
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__);


class MultiCollections extends HTMLElement {
	constructor() {
    super();
    this.navigation = this.querySelector('[data-armada-selector="multi-collection-navigation"]');
    this.activeNavigationClasses = ['opacity-100'];
    this.inactiveNavigationClasses = ['after:scale-x-0', 'opacity-30'];
    this.collectionContainer = this.querySelector('[data-armada-selector="collection-slider-container"]');
    this.templateContent = this.querySelector('[data-armada-selector="multi-collection-template"]').content;
    this.inactiveBlockClasses = ['invisible', 'opacity-0', 'h-0'];
    this.navButtons = [];
    this.autoplayTimer = null;
    this.autoplayInterval = 5000;
    this.autoplayEnabled = false;
  }

  connectedCallback() {
    (0,_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_0__.isArmadaLoaded)(this.init.bind(this));
  }

  init() {
    this.attachEvents();
    this.initAutoplay();
    window.eight.armada.elementRegistry.register({key: 'multi-collections', assetPath: '/assets/component-multi-collections.js'});
  }

  disconnectedCallback() {
    this.clearAutoplayTimer();
  }

  attachEvents() {
    this.navigation.addEventListener('click', this.handleNavigation.bind(this));
    if (window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleNavigation.bind(this));
    }
  }

  handleNavigation(e) {
    const blockIdEl = e.target.closest('[data-nav-btn]');
    if (!blockIdEl) return;

    const blockId = blockIdEl.dataset.blockId;
    if (!blockId) return;

    this.setCollection(blockId);
    this.updateNavigation(blockId);
    this.resetAutoplayTimer();
  }

  setCollection(blockId) {
    const block = this.collectionContainer.querySelector(`[data-block-id="${blockId}"]`);
    if (block) {
      this.displayBlock(block);
    } else {
      this.createBlock(blockId);
    }
  }

  createBlock(blockId) {
    const block = this.templateContent.querySelector(`[data-block-id="${blockId}"]`);
    const blockClone = block.cloneNode(true);
    this.displayBlock(blockClone);
    this.collectionContainer.appendChild(blockClone);
  }

  displayBlock(block) {
    this.hidePreviousBlock();
    block.setAttribute('data-block-visible', true);
    block.classList.remove(...this.inactiveBlockClasses);
    window.eight.eventsEngine.namedEvents.animate(block);
  }

  hidePreviousBlock() {
    const previousBlock = this.collectionContainer.querySelector('[data-block-visible="true"]');
    previousBlock.setAttribute('data-block-visible', false);
    previousBlock.classList.add(...this.inactiveBlockClasses);
    window.eight.eventsEngine.namedEvents.resetAnimation(previousBlock);
  }

  updateNavigation(blockId) {
    this.hidePreviousNavigation();
    this.setActiveNavigation(blockId);
  }

  hidePreviousNavigation() {
    const previousNavigation = this.querySelector('[data-active-nav-item="true"]');
    previousNavigation.setAttribute('data-active-nav-item', false);
    previousNavigation.classList.remove(...this.activeNavigationClasses);
    previousNavigation.classList.add(...this.inactiveNavigationClasses);
  }

  setActiveNavigation(blockId) {
    const activeNavigation = this.querySelector(`[data-block-id="${blockId}"]`);
    activeNavigation.setAttribute('data-active-nav-item', true);
    activeNavigation.classList.add(...this.activeNavigationClasses);
    activeNavigation.classList.remove(...this.inactiveNavigationClasses);
  }

  initAutoplay() {
    if (!this.navigation) return;

    this.navButtons = Array.from(this.navigation.querySelectorAll('[data-nav-btn]'));
    this.autoplayEnabled = this.shouldAutoplay();

    const interval = parseInt(this.dataset.autoplayInterval, 10);
    if (!Number.isNaN(interval) && interval >= 1000) {
      this.autoplayInterval = interval;
    }

    if (!this.autoplayEnabled) {
      return;
    }

    this.setAutoplayTimer();
  }

  shouldAutoplay() {
    if (this.navButtons.length <= 1) return false;
    const autoplayValue = (this.dataset.autoplay || '').toString().trim().toLowerCase();
    return autoplayValue === 'true' || autoplayValue === '1';
  }

  setAutoplayTimer() {
    if (!this.autoplayEnabled) return;
    this.clearAutoplayTimer();
    this.autoplayTimer = window.setTimeout(() => {
      this.goToNextNavigation();
      this.setAutoplayTimer();
    }, this.autoplayInterval);
  }

  clearAutoplayTimer() {
    if (!this.autoplayTimer) return;
    window.clearTimeout(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  resetAutoplayTimer() {
    if (!this.autoplayEnabled) return;
    this.setAutoplayTimer();
  }

  goToNextNavigation() {
    if (!this.autoplayEnabled) return;

    const currentIndex = this.getCurrentNavIndex();
    const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % this.navButtons.length;
    const nextButton = this.navButtons[nextIndex];
    if (!nextButton) return;

    const nextBlockId = nextButton.dataset.blockId;
    if (!nextBlockId) return;

    this.setCollection(nextBlockId);
    this.updateNavigation(nextBlockId);
  }

  getCurrentNavIndex() {
    const currentNav = this.querySelector('[data-active-nav-item="true"]');
    return this.navButtons.findIndex((button) => button === currentNav);
  }
}

customElements.define('multi-collections', MultiCollections);

})();

/******/ })()
;
